import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from './authentication/services/authentication.service';
import { User } from './common/models/user';
import { fail } from 'assert';
import { TranslateService } from './translate';

@Component({
  selector: 'ft-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class FTRootComponent implements OnInit {
  isLoggedIn: Observable<boolean>;
  title = 'Embla Web Shop';
  user = new User();
  tempHidden: boolean;
  isHome: boolean = false;

  public translatedText: string;

  constructor(private activatedRoute: ActivatedRoute, private authenticationService: AuthenticationService, private router: Router, private _translate: TranslateService) {
    this.isLoggedIn = authenticationService.isLoggedIn();
    this.tempHidden = false;
  }

  ngOnInit() {
    this.authenticationService.isLoggedIn().subscribe(loggedIn => {
      this.user = <User>JSON.parse(localStorage.getItem('currentUser'));
    });

    this.router.events.subscribe((val) => {
      if (location.pathname === '/home') {
        this.isHome = true;
      }
      else {
        this.isHome = false;
      }

    });

    this.selectLang('webshop');

  }

  selectLang(lang: string) {
    // set current lang;
    this._translate.use(lang);
    //this.refreshText();
  }

  // refreshText() {
  //   // refresh translation when language change
  //   this.translatedText = this._translate.instant('hello world');
  // }

}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/app.component.ts